import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ContactAPI } from '../services/api';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  const { user } = useAuth();

  const [email, setEmail] = useState(user?.email ?? '');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await ContactAPI.sendMessage(email, subject, message);
      setSuccess(true);
      setSubject('');
      setMessage('');
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page-container contact-page">
      <div className="contact-card card">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-subtitle">Have a question or feedback? We'd love to hear from you.</p>

        {success ? (
          <div className="contact-success">
            <span className="contact-success-icon">✓</span>
            <p>Your message has been sent. We'll get back to you soon.</p>
            <button
              className="btn btn-secondary"
              onClick={() => setSuccess(false)}
            >
              Send another message
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form" noValidate>
            <div className="form-group">
              <label htmlFor="contact-email" className="form-label">Your email</label>
              <input
                id="contact-email"
                type="email"
                className="form-control"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={submitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="contact-subject" className="form-label">Subject</label>
              <input
                id="contact-subject"
                type="text"
                className="form-control"
                placeholder="What's this about?"
                value={subject}
                onChange={e => setSubject(e.target.value)}
                required
                disabled={submitting}
                maxLength={120}
              />
            </div>

            <div className="form-group">
              <label htmlFor="contact-message" className="form-label">Message</label>
              <textarea
                id="contact-message"
                className="form-control contact-textarea"
                placeholder="Tell us more…"
                value={message}
                onChange={e => setMessage(e.target.value)}
                required
                disabled={submitting}
                rows={6}
                maxLength={2000}
              />
              <span className="char-count">{message.length} / 2000</span>
            </div>

            {error && <p className="form-error">{error}</p>}

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={submitting || !email || !subject || !message}
            >
              {submitting ? 'Sending…' : 'Send message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
